import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  button: {
    color: theme.palette.secondary.main
  }
}));

export default function OrderStatusPopup(props) {
  const { orderNo, orderStatus, setTransactionStatus } = props;
  const classes = useStyles();
  const popContent =
    orderStatus === 'failure'
      ? {
          title: 'Transaction Incomplete',
          content:
            'Oops! We were not able to complete your Labor Protection Program extension transaction. Please try again or contact us.'
        }
      : {
          title: 'LPP extension successful',
          content: `You have successfully extended the Labor Protection Program for your selected sites. Check your email for further details. Order number: ${orderNo}.`
        };
  const handleClick = () => {
    setTransactionStatus({ orderNo: '', orderStatus: '' });
  };
  return (
    <Box className={classes.root}>
      <Dialog
        open={!!orderStatus}
        onClose={() => {}}
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle disableTypography>
          <Typography variant="h6">{popContent.title}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">{popContent.content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClick()}
            color="primary"
            variant="contained"
            disableElevation
            className={classes.button}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
